import React from 'react';

export const Card = ({ className, children }) => (
  <div className={`rounded-xl shadow-md bg-white text-black ${className}`}>{children}</div>
);

export const CardContent = ({ className, children }) => (
  <div className={`p-4 ${className}`}>{children}</div>
);
